import { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Splash() {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Total duration: entrance (1000ms) + hold (1200ms) + exit (800ms)
    const total = 3000; // keep splash visible longer so users notice it
    const t = setTimeout(() => setVisible(false), total);
    return () => clearTimeout(t);
  }, []);

  const containerStyle: React.CSSProperties = {
    position: 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#b8872b', // dark gold background for splash
    zIndex: 9999,
  };

  const logoStyle: React.CSSProperties = {
    width: '140px',
    maxWidth: '50%',
    height: 'auto',
    filter: 'drop-shadow(0 6px 18px rgba(0,0,0,0.12))'
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div style={containerStyle} initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0, transition: { duration: 0.8 } }}>
          <motion.img
            src="/logo.png"
            alt="Zam Fabrics Palace"
            style={logoStyle}
            initial={{ x: -160, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 160, opacity: 0 }}
            transition={{ duration: 1.0, ease: 'easeInOut' }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
